// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
export const MeleeFragmentDoc = gql`
    fragment melee on CatalogueMelee {
  __typename
  melee {
    grade {
      categories {
        systemCode
      }
    }
    colors {
      systemCode
      translation(locale: $locale) {
        name
      }
    }
    clarities {
      systemCode
      translation(locale: $locale) {
        name
      }
    }
    caratWeight
    width
  }
  quantity
}
    `;